import styles from './Recommendation.placeholder.module.scss';

export const RecommendationPlaceholder = ({
  withAddToCart = false,
}: {
  withAddToCart?: boolean;
}) => (
  <div
    className={
      withAddToCart ? styles.recommendationWithAddToCard : styles.recommendation
    }
  />
);
